'use strict';
const angular = require('angular');

/*@ngInject*/
export function TasksService($resource) {
  return $resource('/api/tasks/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    getByContext: {
      method: 'GET',
      url: "/api/tasks/context/:id",
      isArray: true
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/tasks/:id/attachments"
    }
  });
}


export default angular.module('conduu.TaskService', [])
  .factory('TaskService', TasksService)
  .name;



// WEBPACK FOOTER //
// ./client/components/tasks/tasks.service.js